import React, {useState, useRef, useEffect} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import Input from "../../forms/Input";
import Button from "../../Button";
import _ from "lodash";
import Select from "../../forms/inputs/Select";

const SURVEY_DEFAULTS = {
    id:             "",
    admin_notes:    "",
    actioned_at:    "no"
}

const CreateEditSurvey = (props) => {
    const {
        jobId       = null,
        surveyId    = null,
        onCancel    = () => {},
        onComplete  = () => {},
        onDelete    = () => {},
    } = props;

    const prepareDefaultValues = () => {
        const defaultSurvey = SURVEY_DEFAULTS;

        if (!!surveyId && surveyId !== "") {
            defaultSurvey.id = parseInt(surveyId);
        }

        return defaultSurvey;
    }

    const [submitting, setSubmitting]               = useState(false);
    const [job, setJob]                             = useState(null);
    const [survey, setSurvey]                       = useState(prepareDefaultValues());
    const [actionedStatuses, setActionedStatuses]   = useState([]);
    const [errors, setErrors]                       = useState(null);

    useEffect(() => {
        load(false);
    }, [jobId]);

    const load = () => {
        axios.get(route('web-api.job.survey.config', {job: jobId, survey_id: surveyId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.job) {
                        setJob(response.data.job);
                    }

                    if (!!response.data.actioned_statuses) {
                        setActionedStatuses(response.data.actioned_statuses);
                    }

                    if (!!response.data.survey) {
                        setSurvey(response.data.survey);
                    } else {
                        setSurvey(SURVEY_DEFAULTS);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const reset = () => {
        setSurvey(prepareDefaultValues());

        setSubmitting(false);
        setErrors(null);
    }

    const payload = () => {
        return {
            method: !!surveyId ? 'patch' : 'post',
            url:    !!surveyId ? route('web-api.job.survey.update', {job: jobId, survey: surveyId}).toString() : route('web-api.job.survey.store', {job: jobId}).toString(),
            data:   {
                ...survey,
            },
        }
    }

    const submit = () => {
        axios(payload())
            .then((response) => {
                reset();
                onComplete(response.data.job_id);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    setErrors(error.response.data.errors);
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }

                setSubmitting(false);
            });
    }

    const handleClose = () => {
        if (!submitting) {
            reset();
            onCancel();
        }
    }

    const onChange = (field, value) => {
        const clone = _.cloneDeep(survey);

        clone[field] = value;

        setSurvey(clone);
    }

    return (
        <React.Fragment>
            <div className="row m-0 p-0">
                <div className="col-12 m-0 p-0 bespoke-input">
                    <Input
                        name={"admin_notes"}
                        label={"Notes"}
                        required={false}
                        type={"textarea"}
                        value={survey.admin_notes}
                        disabled={submitting}
                        onChange={(value) => onChange("admin_notes", value)}
                        error={!!errors && !!errors.admin_notes ? errors.admin_notes : null}
                    />
                </div>
            </div>
            {!!surveyId && (
                <div className="row m-0 p-0">
                    <div className="col-12 m-0 p-0 bespoke-input">
                        <Input
                            name={"actioned_at"}
                            label={"Actioned"}
                            required={false}
                            type={"select"}
                            options={actionedStatuses}
                            value={survey.actioned_at}
                            disabled={submitting}
                            onChange={(value) => onChange("actioned_at", value)}
                            error={!!errors && !!errors.actioned_at ? errors.actioned_at : null}
                        />
                    </div>
                </div>
            )}
            <div className="row m-0 mt-4 p-0">
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center">
                        <Button
                            onClick={() => setSubmitting(true)}
                            label={!!surveyId ? "Save Changes" : "Create"}
                            classes={"btn btn-eh-lilac m-0 mr-4"}
                        />
                        <Button
                            onClick={() => handleClose()}
                            label={"Cancel"}
                            classes={"btn btn-outline-eh-off-black m-0 mr-4"}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default CreateEditSurvey;
